import {Component, OnInit, ViewChild} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgDataTableComponent, ExgModalService} from 'exc-controls-v2';
import {ExcRestService, IExcDataFilter, IExcDataPaging, IExcDataSort} from 'exc-rest-v2';
import {IExcMetaInfo} from 'exc-rest-v2/lib/interfaces/IExcMetaInfo';
import {EnumerationService} from '../../services/enumeration.service';

@Component({
  selector: 'app-modal-oe-group-list',
  templateUrl: './modal-oe-group-list.component.html',
  styles: [
  ]
})
export class ModalOeGroupListComponent extends ExcTranslation implements OnInit {
  @ViewChild('VCoeUserList', {read: ExgDataTableComponent}) VCoeUserList!: ExgDataTableComponent;

  data = {} as any;
  init = true;

  oeGroupList = {
    data: [] as any,
    MetaInfo: {
      dataPaging: {pageNo: 0, pageSize: 25} as IExcDataPaging,
      dataSort: {} as IExcDataSort,
      dataFilter: {} as IExcDataFilter,
    } as IExcMetaInfo,
    paging: {
      pagingPage: 0,
      pagingEndRow: 0,
      pagingPageSize: 25,
      pagingTotalPages: 0,
      pagingTotalRows: 0,
      pagingStartRow: 0,
    },
    isLoading: true,

    selectKey: 'oeID',
    state: 1,
    selectedRow: undefined as any,
    searchValue: '',
    uiFilter: [] as any[],
    uiSort: [] as any[],
    ready: () => {
      if (!this.oeGroupList.data || this.oeGroupList.data.length === 0) {
        this.oeGroupList.state = 2;
        this.VCoeUserList.selectedRow = -1;
      } else {
        this.oeGroupList.state = 0;
        this.VCoeUserList.selectedRow = 0;
      }
      this.init = false;
    },
    selectionChanged: (index: number) => {
      this.oeGroupList.selectedRow = this.oeGroupList.data[index];
    },
    pageChanged: (page: number) => {
      if (this.oeGroupList.MetaInfo.dataPaging !== undefined) {
        this.oeGroupList.MetaInfo.dataPaging.pageNo = page;
      }
      this.oeGroupList.loadData();
    },
    search: (value: string) => {
      this.oeGroupList.searchValue = value;
      this.oeGroupList.pageChanged(1);
    },
    loadData: () => {
      const SELF = this;
      SELF.oeGroupList.state = 1;
      SELF.oeGroupList.isLoading = true;
      SELF.excRestService
        .get(
          SELF.excRestService.computeUrl(
            'OEGroupRListTyp', {
              fts: this.oeGroupList.searchValue,
            }),
          {MetaInfo: SELF.oeGroupList.MetaInfo}
        )
        .subscribe((response) => {
          if (response.success && response.data) {
            SELF.oeGroupList.data = response.data;
            SELF.oeGroupList.paging = response.paging;
          } else {
            SELF.oeGroupList.data = [];
            SELF.oeGroupList.paging = {
              pagingPage: 0,
              pagingEndRow: 0,
              pagingPageSize: 25,
              pagingTotalPages: 0,
              pagingTotalRows: 0,
              pagingStartRow: 0,
            };
          }
          SELF.oeGroupList.ready();
          SELF.oeGroupList.isLoading = false;
        });
    }
  };

  constructor(
    public excRestService: ExcRestService,
    public modal: ExgModalService,
    public enumSvc: EnumerationService
  ) {
    super();
  }

  ngOnInit(): void {
    this.initialize();
  }

  initialize(): void {
    this.oeGroupList.loadData();
  }

  clickedSave(): void {
    this.modal.action(this.oeGroupList.selectedRow);
  }

  clickedCancel(): void {
    this.modal.close();
  }
}
